import React from 'react';
import PropTypes from 'prop-types';
import { pick } from 'underscore';
import { Image } from '@fluentui/react/lib/Image';
import { PrimaryButton } from '@bingads-webui-react/fabric-with-signal';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import googleIconNormal from './btn_google_dark_normal.svg';

const getSignInGoogleStyles = () => ({
  signInGoogle: {
    backgroundColor: '#4285F4',
    paddingLeft: 0,
    paddingRight: 0,

    '&:active': {
      backgroundColor: '#3367d6',
    },

    '&:hover': {
      boxShadow: '0 0 3px 3px rgb(66 133 244 / 30%)',
      backgroundColor: '#4285F4',
    },

    '&:focus-visible': {
      outline: '-webkit-focus-ring-color auto 1px',
    },

    '& .google-sign-in-image': {
      backgroundColor: '#ffffff',
      padding: 6,
    },
    '& .google-sign-in-text': {
      padding: '0px 18px',
      fontFamily: 'Roboto,arial,sans-serif',
    },
  },
});

function UnstyledGoogleLoginButton(props) {
  const { classes, i18n } = props;

  return (
    <React.Fragment>
      <PrimaryButton
        className={`signInButton ${classes.signInGoogle}`}
        {...pick(props, 'data-action-name', 'data-analyticsid', 'onClick')}
      >
        <Image
          className="google-sign-in-image"
          src={googleIconNormal}
          alt={i18n.getString(_TL_('Sign in with Google image'))}
        />
        <div className="google-sign-in-text">
          {i18n.getString(_TL_('Sign in with Google'))}
        </div>
      </PrimaryButton>
    </React.Fragment>
  );
}

UnstyledGoogleLoginButton.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  classes: PropTypes.shape().isRequired,
  onClick: PropTypes.func.isRequired,
};

export const GoogleLoginButton = withDefaultStyles(
  UnstyledGoogleLoginButton,
  getSignInGoogleStyles
);
